import { getPlaceLabel, PlaceType } from '@model/iceberg/geography';
import React from 'react';
import { GeographyResult } from '@model/search';
import { Option } from '@components/common/typeahead/components/option/Option';

const iconMap = {
  [PlaceType.CONTINENT]: 'mhi-map-pin-outline',
  [PlaceType.COUNTRY]: 'mhi-map-pin-outline',
  [PlaceType.REGION]: 'mhi-map-pin-outline',
  [PlaceType.RESORT]: 'mhi-resort',
  [PlaceType.HOTEL]: 'mhi-hotel'
};

const getIcon = (result: GeographyResult) => iconMap[result.type];

const getSubtitle = ({ place, type }: GeographyResult) => {
  if (!place) return null;
  return getPlaceLabel(place, type);
};

export const FITOptions = (props: any) => (
  <Option {...props} getSubtitle={getSubtitle} getIcon={getIcon} attribute={'name.display'} />
);
